import React from 'react'
import { Link } from 'gatsby'

export default ({
    children,
    to,
    dangerouslySetInnerHTML,
    className,
    onClick,
    // Keep these props for backwards compatibility but don't use them
    cover,
    duration,
    direction,
    bg,
    ...rest
}) => {
    if (!to) return null

    const _to = (() => {
        if (to.startsWith('http')) return to

        if (to.startsWith('/')) return to

        return '/' + to
    })()

    // External link
    if (_to.startsWith('http')) {
        return (
            <a
                href={_to}
                dangerouslySetInnerHTML={dangerouslySetInnerHTML}
                className={className}
                onClick={onClick ? onClick : undefined}
                {...rest}
            >
                {children}
            </a>
        )
    }

    // Internal link
    return (
        <Link
            to={_to}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            className={className}
            onClick={onClick ? onClick : undefined}
            {...rest}
        >
            {children}
        </Link>
    )
}
